"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const router_1 = require("@angular/router");
const rxjs_1 = require("rxjs");
const common_1 = require("@angular/common");
const core_2 = require("@ngx-translate/core");
const loading_spinner_1 = require("../commons/ui/loading-spinner");
const file_data_service_1 = require("../v2/commons/file-data.service");
class AppBaseComponent {
    constructor(fileManager, route, router, location, translate) {
        this.fileManager = fileManager;
        this.route = route;
        this.router = router;
        this.location = location;
        this.translate = translate;
        this.projects = [];
        this.teams = [];
        this.processing = [];
        this.uploads = [];
        this._subs = [];
        this.config = {
            panels: [
                {
                    id: 'app',
                    dock: 'top left right bottom',
                    height: 'full',
                    header: {
                        id: 'navbar',
                        dock: 'top left right',
                        height: 50,
                        items: [
                            { id: 'logo', dock: 'left' }, { id: 'burger', dock: 'left' }, { id: 'team', dock: 'left' },
                            { id: 'profile', dock: 'right' }, { id: 'config', dock: 'right' }, { id: 'help', dock: 'right' },
                        ]
                    },
                    content: {
                        id: 'map',
                        dock: 'top bottom left right',
                        height: 'full',
                        items: [
                            { id: 'sidenav', dock: 'left' }
                        ]
                    }
                }
            ]
        };
    }
    ngOnInit() {
        loading_spinner_1.LoadingSpinner.end();
        this.fileManager.init().subscribe();
        rxjs_1.combineLatest(this.fileManager.onReady(), this.route.params).subscribe(([_, params]) => {
            console.log('TEAMS', params);
            // listen to param changes
            if (params.team) {
                var team = this.fileManager.teams.values.find(t => t.uid == params.team);
                if (team)
                    // this will trigger everyone else
                    this.fileManager.initTeam(team).subscribe();
                else
                    throw new Error("Invalid team for this account " + params.team);
            }
        });
        this._subs.push(this.fileManager.processingItems.state.subscribe(s => this.processing = s));
        this._subs.push(this.fileManager.uploadingFiles.state.subscribe(s => this.uploads = s));
        this._subs.push(this.fileManager.uploadingQueue.state.subscribe(s => this.uploads = s));
        this._subs.push(this.fileManager.projects.state.subscribe(s => this.projects = s));
        this._subs.push(this.fileManager.teams.state.subscribe(s => this.teams = s));
        this._subs.push(this.fileManager.team.events.subscribe(s => {
            if (s.event == 'ADD') {
                this.team = s.item;
                var path = this.router.url;
                if (path.indexOf('?') != -1)
                    path = path.substring(0, path.indexOf('?'));
                var v = path.split('/');
                v[0] = '/' + v[0];
                // if teams changed, redirect to same place on new team
                if (v[2] != s.item.uid) {
                    v[2] = s.item.uid;
                    this.router.navigate(v);
                }
            }
            else if (s.event == 'REMOVE') {
                this.team = null;
            }
        }));
    }
    ngOnDestroy() {
        this._subs.forEach(s => s.unsubscribe());
    }
    setTeam(uid) {
        this.fileManager.initTeam(this.fileManager.teams.values.find(t => t.uid == uid)).subscribe();
    }
    goto(url) {
        this.router.navigate(url, { relativeTo: this.route });
    }
}
exports.AppBaseComponent = AppBaseComponent;
class HomeComponent {
    constructor() {
        this.config = null;
    }
    ngOnChanges() { }
}
exports.HomeComponent = HomeComponent;
class XsPanelComponent {
    constructor() {
        this.config = null;
    }
    ngOnChanges() { }
}
exports.XsPanelComponent = XsPanelComponent;
class XsPanelItemsComponent {
    constructor() {
        this.config = null;
        this.left = null;
        this.center = null;
        this.right = null;
    }
    ngOnChanges() {
        if (this.config && this.config.items) {
            this.config.items.forEach(item => {
                if (item.dock.indexOf('right') !== -1) {
                    if (!this.right) {
                        this.right = [];
                    }
                    this.right.push(item);
                }
                else if (item.dock.indexOf('center') !== -1) {
                    if (!this.center) {
                        this.center = [];
                    }
                    this.center.push(item);
                }
                else {
                    if (!this.left) {
                        this.left = [];
                    }
                    this.left.push(item);
                }
            });
        }
        if (this.right) {
            this.right.reverse();
        }
    }
}
exports.XsPanelItemsComponent = XsPanelItemsComponent;
class XsDebugComponent {
    constructor() {
        this.item = null;
        this.label = null;
    }
    ngOnChanges() {
    }
}
exports.XsDebugComponent = XsDebugComponent;
